import React, { Component } from 'react';
import PropTypes            from 'prop-types';


export default class TextInput extends Component {

  constructor(props) {
    super(props);

    const { showText, isNotVisibleMsg, password } = this.props;

    this.state = {
      passwordStatusText   : showText || '',
      passwordTypeSelector : password ? 'password' : 'text',
      visibilityStatusText : isNotVisibleMsg || ''
    };

    this.togglePassword       = _togglePassword.bind(this);
    this.applyTextInputStyles = _applyTextInputStyles.bind(this);

  }

  componentDidMount() {
    this.applyTextInputStyles(this.props.inputState);
  }

  componentWillReceiveProps(nextProps) {
    this.applyTextInputStyles(nextProps.inputState);
  }

  render() {

    const { labelStyle, inputStyle, spanStyle, passwordStatusText, visibilityStatusText, passwordTypeSelector, butttonStyle, labelFocusStyle, labelStyleTmp  }  = this.state;
    const { inputState, id, labelText, password, placeholder, infoMessage, errorMessage, changeHandler } = this.props;

    const em = (inputState === 'error' && errorMessage) ? `errMsg-${id} ` : '';
    const ariaDescribedby =  em + ((infoMessage) ? `infoMsg-${id}` : '');

    return (
      <div>
        <label className={labelStyleTmp} htmlFor={id}>{labelText}</label>

        <input
          id               = {id}
          type             = {passwordTypeSelector}
          placeholder      = {placeholder}
          className        = {inputStyle}
          aria-describedby = {ariaDescribedby}
          aria-invalid     = {inputState === 'error'}
          disabled         = {inputState === 'disabled'}
          readOnly         = {inputState === 'readOnly'}
          onFocus          = {() => this.setState({labelStyleTmp:labelFocusStyle})}
          onBlur           = {() => this.setState({labelStyleTmp:labelStyle})}
          onChange         = {changeHandler}
        />

        {(inputState  !== 'readOnly' || inputState !== 'disabled') && <span className={spanStyle} />}
        {password     && <span><button type="button" className={butttonStyle} id={`showbutton-${id}`} onClick={this.togglePassword} disabled={inputState === 'disabled'}>{passwordStatusText}</button> <span aria-live="polite" aria-atomic="true" className="pe-sr-only">{visibilityStatusText}</span></span>}
        {infoMessage  && <span id={`infoMsg-${id}`} className="pe-input--info_message">{infoMessage}</span>}
        {inputState === 'error' && errorMessage && <span id={`errMsg-${id}`} className="pe-input--error_message">{errorMessage}</span>}
      </div>
    );

  }
}


TextInput.propTypes = {
  id                 : PropTypes.string.isRequired,
  labelText          : PropTypes.string.isRequired,
  changeHandler      : PropTypes.func.isRequired,
  placeholder        : PropTypes.string,
  'aria-describedby' : PropTypes.string,
  inputState         : PropTypes.string,
  infoMessage        : PropTypes.string,
  errorMessage       : PropTypes.string,
  'aria-invalid'     : PropTypes.bool,
  fancy              : PropTypes.bool,
  password           : PropTypes.bool
};


function _togglePassword() {
  const { passwordTypeSelector, passwordStatusText } = this.state;
  const { showText, hideText, isNotVisibleMsg, isVisibleMsg } = this.props;

  const passwordTypeSelectorTmp = (passwordTypeSelector === 'password') ? 'text' : 'password';
  const visibilityStatusTextTmp = (passwordStatusText === showText) ? isVisibleMsg : isNotVisibleMsg;
  const passwordStatusTextTmp   = (passwordStatusText === showText) ? hideText : showText;

  this.setState({passwordTypeSelector:passwordTypeSelectorTmp, passwordStatusText:passwordStatusTextTmp, visibilityStatusText: visibilityStatusTextTmp});

};

function _applyTextInputStyles( inputState ) {
  let { labelStyle, inputStyle, spanStyle, butttonStyle, labelFocusStyle } = this.state;
  const { fancy } = this.props;

  switch (inputState) {
    case 'error':
      labelStyle      = 'pe-textLabelInput__label--label_error';
      inputStyle      = fancy ? 'pe-textInput--input_error' : 'pe-textInput--basic_error';
      spanStyle       = fancy ? 'pe-inputError_underline'   : '';
      butttonStyle    = fancy ? 'pe-textInput__showButton--error'  : 'pe-textInput__showButton-basic'
      labelFocusStyle = 'pe-textLabelInput__label--label_error';
      break;
    case 'disabled':
      labelStyle      = 'pe-textLabelInput__label';
      inputStyle      = fancy ? 'pe-textInput' : 'pe-textInput--basic';
      spanStyle       = '';
      butttonStyle    = fancy ? 'pe-textInput__showButton--disabled' : 'pe-textInput__showButton-basic--disabled';
      break;
    case 'readOnly':
      labelStyle      = 'pe-textLabelInput__label';
      inputStyle      = 'pe-textInput--input_readonly';
      spanStyle       = '';
      butttonStyle    = 'pe-textInput__showButton';
      labelFocusStyle = 'pe-textLabelInput__label';
      break;
    default:
      labelStyle      = 'pe-textLabelInput__label';
      inputStyle      = fancy ? 'pe-textInput'             : 'pe-textInput--basic';
      spanStyle       = fancy ? 'pe-input_underline'       : '';
      butttonStyle    = fancy ? 'pe-textInput__showButton' : 'pe-textInput__showButton-basic';
      labelFocusStyle = 'pe-textLabelInput__label--label_focus';
  };

  this.setState({labelStyle, labelStyleTmp:labelStyle, inputStyle, spanStyle, butttonStyle, labelFocusStyle});

};



// WEBPACK FOOTER //
// ./src/TextInput.js